exports.logrocketExposeSession = function (LogRocket) {
  LogRocket.getSessionURL((sessionURL) => {
    let regex = /\/s\/(.*)(\?)/;
    const matches = regex.exec(sessionURL);
    window.logrocketSessionId = matches[1];
    window.postMessage(
      { type: "logrocket-expose-session", text: matches[1] },
      "*"
    );
    window.addEventListener(
      "message",
      (event) => {
        // We only accept messages from ourselves
        if (event.source != window) return;

        if (
          event.data.type &&
          event.data.type == "logrocket-expose-session-get"
        ) {
          window.postMessage(
            { type: "logrocket-expose-session", text: matches[1] },
            "*"
          );
        }
      },
      false
    );
  });
};
